exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button[data-v-34485fdf]{color:#fff!important}", ""]);

// exports
